import { Text, SegmentedControl, SegmentedControlProps } from "@mantine/core";

interface Props extends SegmentedControlProps {
  label?: string;
}

export const DisplayModeControl = (props: Partial<Props>) => {
  return (
    <>
      {props.label && (
        <Text size="sm" fw={500} mb={3} mt="sm">
          {props.label}
        </Text>
      )}
      <SegmentedControl
        {...props}
        mt="0"
        data={[
          { label: "Dark", value: "d" },
          { label: "Light", value: "l" },
          { label: "System", value: "s" },
        ]}
      />
    </>
  );
};
